"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UICaret = _interopRequireDefault(require("../icon/icons/UICaret"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var TShirtSize = _interopRequireWildcard(require("../utils/propTypes/tshirtSize"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _IconConstants = require("../icon/IconConstants");

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

// Inline style objects for deprecated `textElement` prop use case.
var indicatorCanvasStyle = {
  display: 'block',
  width: '100%',
  visibility: 'hidden'
};
var indicatorCaretStyle = {
  position: 'absolute',
  width: '100%',
  left: 0,
  top: 0
};

var renderIcon = function renderIcon(textElement) {
  if (textElement !== 'span') {
    _devLogger.default.warn({
      message: 'UIAccordionItem: the `textElement` prop is no longer recommended ' + 'and may be removed in the future. Please use the `size` prop instead.',
      key: 'UIAccordionItem: use size prop'
    });
  } // To fix a bug in IE11 with extra space added to the SVG, this uses a
  // <canvas> element as a sibling to the SVG to work around it (detailed in
  // https://stackoverflow.com/a/30416241). Hack passed inline to keep this
  // more portable and keep the logic in the component vs. the stylesheet


  if (textElement === 'span') {
    return _react.default.createElement("div", {
      className: "private-accordion__indicator"
    }, _react.default.createElement("canvas", {
      width: _IconConstants.CARET_WIDTH,
      height: _IconConstants.CARET_HEIGHT,
      style: indicatorCanvasStyle
    }), _react.default.createElement(_UICaret.default, {
      style: indicatorCaretStyle,
      viewBoxHeight: _IconConstants.CARET_HEIGHT,
      viewBoxWidth: _IconConstants.CARET_WIDTH,
      width: 12
    }));
  }

  return _react.default.createElement(_UIIcon.default, {
    className: "private-accordion__indicator",
    name: "right"
  });
};

var UIAccordionItem =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIAccordionItem, _PureComponent);

  function UIAccordionItem(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIAccordionItem);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAccordionItem).call(this, props));
    _this.state = {
      openComplete: props.open
    };
    _this.handleCloseStart = _this.handleCloseStart.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenComplete = _this.handleOpenComplete.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTitleClick = _this.handleTitleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIAccordionItem, [{
    key: "handleCloseStart",
    value: function handleCloseStart() {
      this.setState({
        openComplete: false
      });
    }
  }, {
    key: "handleOpenComplete",
    value: function handleOpenComplete() {
      this.setState({
        openComplete: true
      });
    }
  }, {
    key: "handleTitleClick",
    value: function handleTitleClick() {
      var _this$props = this.props,
          onOpenChange = _this$props.onOpenChange,
          open = _this$props.open;
      onOpenChange((0, _SyntheticEvent.default)(!open));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          animate = _this$props2.animate,
          children = _this$props2.children,
          Content = _this$props2.Content,
          contentClassName = _this$props2.contentClassName,
          disabled = _this$props2.disabled,
          __onOpenChange = _this$props2.onOpenChange,
          open = _this$props2.open,
          size = _this$props2.size,
          textElement = _this$props2.textElement,
          title = _this$props2.title,
          titleClassName = _this$props2.titleClassName,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["animate", "children", "Content", "contentClassName", "disabled", "onOpenChange", "open", "size", "textElement", "title", "titleClassName"]);
      var TextElement = textElement; // 'span' by default

      var computedTitleClassName = (0, _classNames.default)(titleClassName, 'private-accordion', "private-accordion--" + TShirtSize.fromProp(size).short, {
        'private-accordion--open': open,
        'private-accordion--legacy': textElement !== 'span'
      });
      return _react.default.createElement("div", rest, _react.default.createElement(_UIClickable.default, {
        "aria-expanded": open,
        className: computedTitleClassName,
        "data-open-complete": this.state.openComplete,
        disabled: disabled,
        onClick: this.handleTitleClick
      }, _react.default.createElement(TextElement, {
        className: "private-accordion__text-wrapper"
      }, renderIcon(textElement), title)), _react.default.createElement(_AccordionTransition.default, {
        Content: Content,
        duration: animate ? undefined : 0,
        className: (0, _classNames.default)('UIAccordionItem-content', 'private-accordion__content', contentClassName),
        onCloseStart: this.handleCloseStart,
        onOpenComplete: this.handleOpenComplete,
        open: open
      }, children));
    }
  }]);
  return UIAccordionItem;
}(_react.PureComponent);

UIAccordionItem.propTypes = {
  animate: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node,
  Content: _component.default,
  contentClassName: _react.PropTypes.string,
  disabled: _react.PropTypes.bool.isRequired,
  onOpenChange: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  textElement: _component.default,
  title: _react.PropTypes.node.isRequired,
  titleClassName: _react.PropTypes.string,
  size: TShirtSize.allSizes
};
UIAccordionItem.defaultProps = {
  animate: true,
  disabled: false,
  open: false,
  size: 'extra-small',
  textElement: 'span'
};
UIAccordionItem.displayName = 'UIAccordionItem';

var _default = (0, _Controllable.default)(UIAccordionItem, ['open']);

exports.default = _default;
module.exports = exports.default;